import { OutlineElement } from '@phase2/outline-core';
import { html, TemplateResult, CSSResultArray } from 'lit';
import { AdoptedStyleSheets } from '@phase2/outline-adopted-stylesheets-controller';
import { customElement } from 'lit/decorators.js';
import componentStyles from './pc-topic-card.css.lit';
import globalStyles from './pc-topic-card.lightDom.css.lit';
/**
 * Topic card component
 * @element pc-topic-card
 * @slot - This element has a default slot
 */
@customElement('pc-topic-card')
export class PCTopicCard extends OutlineElement {
  static styles: CSSResultArray = [componentStyles];
  adoptedStylesheets: AdoptedStyleSheets;

  connectedCallback() {
    super.connectedCallback();
    this.adoptedStylesheets = new AdoptedStyleSheets(globalStyles);
    this.addController(this.adoptedStylesheets);
  }

  render(): TemplateResult {
    return html`
      <div class="topic-card">
        <div class="topic-card--image"><slot name="image"></slot></div>
        <div class="topic-card--content">
          <div class="topic-card--content-main">
            <slot name="eyebrow"></slot>
            <slot name="heading"></slot>
            <slot name="description"></slot>
          </div>
          <div class="topic-card--cta-wrapper">
            <slot name="cta"></slot>
          </div>
        </div>
      </div>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'pc-topic-card': PCTopicCard;
  }
}
